import React, { useRef, useState, useEffect } from 'react';
import { SCommonTable, SActionBtn, STableActions} from 'shj-components';
import { Badge } from 'antd';
// import { api, APIS } from '@/api';

import SubRulesModel from './components/subRulesModel'; //子规则modal 
import moment from 'moment';
import {iiHOC} from '@/utils/auth';
import { isNil } from 'lodash-es';
import { businessMattersDetails } from '@/services/integrationConfig'
interface Props {
  clueId: number;
  listRef: any;
  list: any;
  currentRow: any;
}
/**
 * moment类型转日期
 * @param  momentVal moment类型的日期 默认格式 年-月-日
 */
const momentToDate = (momentVal: any, format = 'YYYY-MM-DD') => {
  // if (!moment.isMoment(momentVal)) return;
  return momentVal ? moment(momentVal).format(format) : null;
};

/**
 * 日期转moment类型
 * @param dateVal 字符串的日期 默认格式 年-月-日
 *      headers: { 'Content-Type': 'application/json' },
 */
const dateToMoment = (dateVal: string, format = 'YYYY-MM-DD') => {
  return dateVal ? moment(dateVal, format) : null;
};

const ExpandTable: React.FC<Props> = ({ clueId, listRef, list, currentRow }) => {
  const tableRef = useRef<any>();
  const wrapRef = useRef<any>();
  const [authArr, setAuthArr] = useState([]);
  const [subRuleDetails, setSubRuleDetails] = useState({}); //子规则信息
  const [currentBusinessMatters, setCurrentBusinessMatters]: any = useState({}); //当前选中的业务事项
  const [state, setState] = useState(true);
  useEffect(() => {
    setState(false);
    setTimeout(() => {
      setState(true);
    }, 100);
  }, [list]);
  const fetchData = () => {
    return new Promise((resolve: any) => {
      resolve({
        data: { data: list },
        success: true,
      });
    });
  };

  const add = (type: string, record: any = {}) => {
    const { ruleConfigId, businessMattersId, businessMatters } = record;
    // setSubRuleDetails({
    //   ...subRuleDetails,
    //   businessMattersData: currentBusinessMatters,
    //   businessMattersId: record?.businessMattersId, //业务事项id
    //   // ruleForm: form,
    //   visible: true,
    //   type,
    //   currentItem: record,
    // });

    getBusinessMattersDetails(businessMattersId, type, record, {
      id: ruleConfigId,
      businessMattersId,
      businessMatters,
      // ruleEnableTime: dateToMoment(record?.ruleEnableTime),
      // ruleStopTime: dateToMoment(record?.ruleStopTime),
      ruleEnableTime: dateToMoment(currentRow?.enableTime),
      ruleStopTime: dateToMoment(currentRow?.stopTime),
    });
  };

  const getBusinessMattersDetails = (businessMattersId: any, type: string, record: any, businessMattersData: any) => {
    businessMattersDetails(businessMattersId).then((resp: any) => {
      console.log(resp);
      if (isNil(resp)) return;
      const { businessParamJson } = resp;
      setCurrentBusinessMatters({ ...businessMattersData, businessParamJson });

      setSubRuleDetails({
        ...subRuleDetails,
        businessMattersData: { ...businessMattersData, businessParamJson },
        businessMattersId: businessMattersId, //业务事项id
        // ruleForm: form,
        ruleForm: businessMattersData,
        visible: true,
        type,
        currentItem: record,
      });
    })
    .finally(() => {});
      
  };

  const onFromSubmit = (values: any) => {
    console.log(values);
    console.log('update');
  };
  const onCancel = () => {
    setSubRuleDetails({
      ...subRuleDetails,
      visible: false,
    });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = tableRef;
    reload();
  };
  const cols = [
    {
      title: '子规则编码',
      dataIndex: 'code',
      width: 140,
    },
    {
      title: '子规则名称',
      dataIndex: 'name',
      width: 140,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 100,
      render: (text: any) => {
        return (
          <div>
            {text ? (
              <>
                <Badge status="success" />
                启用
              </>
            ) : (
              <>
                <Badge status="error" />
                禁用
              </>
            )}
          </div>
        );
      },
    },
    {
      title: '启用时间',
      dataIndex: 'enableTime',
      width: 140,
      render: (text: any) => {
        return momentToDate(text)
      }
    },
    {
      title: '停用时间',
      dataIndex: 'stopTime',
      width: 120,
      render: (text: any) => {
        return momentToDate(text)
      }
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      render: (text: any, record: any) => {
        return iiHOC(
          <div className="actionBox">
            <STableActions>
              <SActionBtn onClick={() => add('edit', record)}>
                编辑
              </SActionBtn>
              <SActionBtn onClick={() => add('view', record)}>
                查看
              </SActionBtn>
            </STableActions>
          </div>,
        );
      },
    },
  ];
  return (
    state && (
      <>
        <SCommonTable
          request={fetchData}
          toolbarTitle={'子规则列表'}
          ref={tableRef}
          tableType={'antd'}
          columns={cols}
          scroll={{ y: 400 }}
          pagination={false}
          size="small"
        />
        <SubRulesModel
          props={subRuleDetails}
          listRef={listRef}
          onFromSubmit={onFromSubmit}
          onCancelSubRule={onCancel}
        />
      </>
    )
  );
};

export default ExpandTable;
